<template>
    <amplify-authenticator>
        <amplify-sign-in
            slot="sign-in"
        >
            <div slot="federated-buttons"/>
        </amplify-sign-in>
        <amplify-sign-up
            slot="sign-up"
            :form-fields.prop="formFields"
        ></amplify-sign-up>
        <!-- <div>
            <amplify-sign-out></amplify-sign-out>
        </div> -->
    </amplify-authenticator>
</template>

<script>
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
export default {
    name: "Auth",
    data() {
        return {
            unsubscribeAuth: undefined,
            formFields: [
                {
                    type: "username",
                    label: "Username *",
                    placeholder: "Enter your username",
                    inputProps: { required: true, autocomplete: "username" },
                },
                {
                    type: "password",
                    label: "Password *",
                    placeholder: "Enter your password",
                    inputProps: {
                        required: true,
                        autocomplete: "new-password",
                    },
                },
                {
                    type: "email",
                    label: "Email Address *",
                    placeholder: "Enter your email address",
                    inputProps: { required: true, autocomplete: "email" },
                },
                {
                    type: "custom:branch",
                    label: "Branch code *",
                    placeholder: "Enter branch code (เช่น: สาขาสุขุมวิท 33 ให้ใส่รหัส 1000)",
                    inputProps: { required: true, autocomplete: null },
                },
                {
                    type: "custom:firstname",
                    label: "Firstname *",
                    placeholder: "Enter your firstname",
                    inputProps: { required: true, autocomplete: null },
                },
                {
                    type: "custom:lastname",
                    label: "Lastname *",
                    placeholder: "Enter your lastname",
                    inputProps: { required: true, autocomplete: null },
                },
            ],
        };
    },
    created() {
        this.unsubscribeAuth = onAuthUIStateChange(
            async (authState, authData) => {
                console.log("authState:", authState);
                this.authState = authState;
                switch (authState) {
                    case "signedin":
                        {
                            // NOTE load user data
                            this.user = authData;

                            const u = {
                                id: this.user.attributes.sub,
                                "custom:branch": this.user.attributes["custom:branch"],
                                "custom:firstname": this.user.attributes["custom:firstname"],
                                "custom:lastname": this.user.attributes["custom:lastname"],
                            };

                            console.log("u:", this.user);

                            this.$router.push("/portal", (err) => {
                                console.log(err, "ignored");
                            });

                            this.$store.dispatch("sale/syncSale", u);
                        }
                        break;

                    default:
                        break;
                }
            }
        );
    },
    beforeDestroy() {
        this.unsubscribeAuth();
    },
};
</script>
